// react
import React from 'react';

// components
import { Icon } from '@/components/atoms/Icon/Icon';

// mui
import { Box, Button, Container, Divider, Stack } from '@mui/material';

export interface ModalPageTemplateProps {
  children?: React.ReactNode;
  /** Omit to hide the back button. */
  onBack?: () => void;
  footerSlot?: React.ReactNode;
}

/**
 * ModalPageTemplate shows a back button on the top left, and the specific
 * children content underneath.
 *
 * When footerSlot is provided, the layout switches to a fixed-height model:
 * the back button and footer stay pinned at the top/bottom while the children
 * scroll independently in between.
 */
export const ModalPageTemplate = ({
  children,
  onBack,
  footerSlot,
}: ModalPageTemplateProps) => {
  return (
    <Stack
      direction='column'
      sx={{
        height: '100%',
        backgroundColor: 'background.default',
      }}
    >
      {onBack && (
        <Stack
          sx={{
            gap: { xs: 1, sm: 2 },
            backgroundColor: 'background.default',
            paddingTop: { xs: 1, sm: 2 },
          }}
        >
          <Container maxWidth={false}>
            <Button
              aria-label='back'
              variant='text'
              startIcon={<Icon icon='chevron-left' fontSize={16} />}
              size='small'
              onClick={onBack}
            >
              BACK
            </Button>
          </Container>
          <Divider />
        </Stack>
      )}
      <Box
        sx={{
          flex: 1,
          overflow: 'auto',
          minHeight: 0,
        }}
      >
        {children}
      </Box>
      {footerSlot}
    </Stack>
  );
};

ModalPageTemplate.displayName = 'ModalPageTemplate';
export default ModalPageTemplate;
